/**
 * Extract a user-safe trade error from an API/mutation failure.
 * Never surface infrastructure / config dump messages in the UI.
 */
export function getTradeErrorMessage(
  error: unknown,
  fallback: string
): string {
  const apiError = getApiErrorString(error);
  if (apiError && !looksLikeInternalError(apiError)) {
    return apiError;
  }

  if (error instanceof Error && error.message && !looksLikeInternalError(error.message)) {
    return error.message;
  }

  return fallback;
}

function getApiErrorString(error: unknown): string | null {
  if (!error || typeof error !== "object") return null;
  const response = (error as { response?: { data?: { error?: unknown } } })
    .response;
  const apiError = response?.data?.error;
  return typeof apiError === "string" && apiError.trim() ? apiError.trim() : null;
}

function looksLikeInternalError(message: string): boolean {
  return /rabbitmq|amqp:\/\/|RABBITMQ_|correlationId|ECONNREFUSED|ENOTFOUND|ENOENT|stack trace|at\s+\S+\s+\(|set [A-Z_]{3,}/i.test(
    message
  );
}
